import { authedFetch } from "../utils";
import { getCognitoUser } from "./token";

const apiRoot = process.env.REACT_APP_API_ROOT;
const apiGetManifests = process.env.REACT_APP_API_GET_MICROFRONTEND_MANIFESTS;

/**
 *
 * @returns {Promise<import("@enpowered/microfrontends").MicroFrontendManifest[]>}
 */
export const getMicrofrontendManifests = async () => {
  const isAuthorized = getCognitoUser();
  const manifestsURL =
    apiGetManifests ||
    `${apiRoot}/v1/microfrontends/${
      isAuthorized ? "scoped-manifests" : "manifests"
    }`;
  const fetch = !apiGetManifests && isAuthorized ? authedFetch : window.fetch;
  return fetch(manifestsURL)
    .then(res => res.json())
    .then(res => res.data.map(row => row.attributes));
};

/**
 *
 * @param {string[]} [manifestOverrides]
 * @returns {Promise<import("@enpowered/microfrontends").MicroFrontendManifest[]>}
 */
export const getMicrofrontendManifestsWithOverrides = (
  manifestOverrides = []
) => {
  const allowedDomains = [/getenpowered.com$/, /localhost:\d{4,5}$/];
  return Promise.all([
    getMicrofrontendManifests(),
    Promise.all(
      manifestOverrides
        .filter(url =>
          allowedDomains.some(rgx => rgx.test(new URL(url).origin))
        )
        .map(url =>
          fetch(url)
            .then(res => res.json())
            .then(data => {
              const urlParams = new URL(url);
              return {
                ...data,
                entry: `${urlParams.origin}${urlParams.pathname.replace(
                  "/microfrontend-manifest.json",
                  ""
                )}/remoteEntry.js`
              };
            })
        )
    )
  ])
    .then(([manifests, overrides]) => {
      return manifests
        .map(manifest => {
          const override =
            overrides.find(o => o.scope === manifest.scope) || manifest;
          return override;
        })
        .concat(
          overrides.filter(o => !manifests.map(m => m.scope).includes(o.scope))
        );
    })
    .then(manifests => {
      console.log(manifests);
      return manifests;
    });
};
